// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KS8U9wyREMI33f_m{display:flex;flex-direction:row;column-gap:16px;margin-top:16px;height:100%;max-width:100%}.KS8U9wyREMI33f_m .bDpJQYVTUwjwEs5B{width:100%;max-width:100%;flex-shrink:1}.KS8U9wyREMI33f_m .IIt7NFx2DJYDpxsa{min-height:888px;max-height:1200px}.KS8U9wyREMI33f_m .Y4R0_AsUmyQ4y4oY{width:100%;margin:16px auto}.cpVBczsQwnUy369L{max-width:325px;margin:0 auto;text-align:center}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"singleGoalContainer": `KS8U9wyREMI33f_m`,
	"mainContentContainer": `bDpJQYVTUwjwEs5B`,
	"slideoutContainer": `IIt7NFx2DJYDpxsa`,
	"activityButton": `Y4R0_AsUmyQ4y4oY`,
	"modalContent": `cpVBczsQwnUy369L`
};
export default ___CSS_LOADER_EXPORT___;
